import Vue from "vue"
import ModernToast from "@/components/UI/ModernToast.vue"

const ToastPlugin = {
    install(Vue, options = {}) {
        const defaultDuration = options.duration || 4000

        // Create a toast instance and mount it
        const ToastConstructor = Vue.extend(ModernToast)
        const toastInstance = new ToastConstructor()
        toastInstance.$mount()
        document.body.appendChild(toastInstance.$el)

        // Expose the $toast API (same interface as vue-toast-notification)
        Vue.prototype.$toast = {
            success(message, opts = {}) {
                toastInstance.addToast(message, "success", opts.duration || defaultDuration)
            },
            error(message, opts = {}) {
                toastInstance.addToast(message, "error", opts.duration || defaultDuration)
            },
            warning(message, opts = {}) {
                toastInstance.addToast(message, "warning", opts.duration || defaultDuration)
            },
            info(message, opts = {}) {
                toastInstance.addToast(message, "info", opts.duration || defaultDuration)
            },
            open(opts = {}) {
                const type = opts.type || "info"
                const message = opts.message || ""
                const duration = opts.duration || defaultDuration
                toastInstance.addToast(message, type, duration)
            },
        }
    },
}

export default ToastPlugin
